// The API refuses an expired, wrong or finished customer-form link with a message written for the
// seller; useApiHelper surfaces it as the error message. Anything without one (a network error, a 500)
// reads "HTTP Error: ..." and gets the fallback instead.
export function refusalMessage(error: unknown, fallback: string): string {
  const message = error instanceof Error ? error.message : "";
  return message && !message.startsWith("HTTP Error") ? message : fallback;
}
